import styled from "styled-components";

interface IProps {
    text?: string
    textsub?: string
}

export const GlowTitle = (props: IProps) => {
    return (
        <StyledGlowTitle>
            <span className="glow-text">{props.text || "title"}</span>
        </StyledGlowTitle>
    );
};

const StyledGlowTitle = styled.div`
    display: block;
    text-align: center;
    margin-bottom: 30px;
    .glow-text {
        font-size: 48px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        position: relative;
        text-transform: uppercase;
        transform: scaleY(1.5);
        display: inline-block;
        text-shadow: 0 0 5px rgba(255, 255, 255, 0.6), 
                    0 0 10px rgba(255, 255, 255, 0.5), 
                    0 0 15px rgba(255, 255, 255, 0.4), 
                    0 0 20px rgba(255, 255, 255, 0.3);

        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.6));
    }
`;

export const GlowTextReward = (props: IProps) => {
    return (
        <StyledGlowTextReward>
            <span className="glow-text">{props.text || "Reward"}</span>
            <span className="glow-text">{props.textsub}</span>
        </StyledGlowTextReward>
    );
};

const StyledGlowTextReward = styled.div`
    display: block;
    text-align: center;
    margin-bottom: 100px;
    .glow-text {
        font-size: 36px;
        font-weight: bold;
        color: #FFF0B6;
        text-align: center;
        position: relative;
        display: block;
        text-shadow: rgba(255, 240, 182, 0.6) 0px 0px 0px, rgba(255, 240, 182, 0.5) 0px 0px 0px, rgba(255, 240, 182, 0.4) 0px 0px 0px, rgba(255, 240, 182, 0.3) 0px 0px 20px;

        filter: drop-shadow(0 0 5px rgba(255, 240, 182, 0.6));
    }
    
`;